import moment from 'moment';
import { useState, useEffect } from 'react';
import { BehaviorSubject, skip, take } from 'rxjs';
import { Count } from 'api/models';
import { Start } from 'api/notifications';
import { fetch } from './fetch';
import { Empty, FetchInfo, NotificationCount } from './models';
import { lastSeenAt, seen } from './use-pending';
export const useNotificationsStore = (status, filter, [, accountId], [, userId], seeing = false, selectedCompany)=>{
    const [content, setContent] = useState(Empty);
    const [force, setForce] = useState(0);
    const refresh = ()=>queueMicrotask(()=>setForce(force + 1));
    // notify the server that the user has seen the notifications
    useEffect(()=>{
        if (seeing) {
            seen(moment());
        }
    }, [
        seeing,
        force
    ]);
    useEffect(()=>{
        const subscriptions = [];
        // create a new observable to hold and tract the notification data
        const content$ = new BehaviorSubject(Empty);
        subscriptions.push(content$.pipe(skip(1)).subscribe(setContent));
        // fetch new notifications when the last seen at changes or user clicks fetch more
        fetch(status, filter, content$, subscriptions, FetchInfo(Count(10), Start(), NotificationCount(5)), lastSeenAt().pipe(take(1)), selectedCompany);
        return ()=>subscriptions.forEach((s)=>s.unsubscribe());
    }, [
        accountId,
        userId,
        status,
        filter,
        force,
        selectedCompany
    ]);
    // When the content$ observable emits a new value, we update the state content.
    // All teh components using this hook will be re-rendered with the new content.
    return {
        content,
        refresh
    };
};
